// import React, { useEffect, useState } from 'react';
// import { IoMdCreate, IoIosCheckmark, IoIosAdd, IoIosClose } from "react-icons/io";
// import { Editor } from "primereact/editor";
// import { InputTextarea } from 'primereact/inputtextarea';
// import { Api } from '../../../../services/api';

// function GoMarketStrategy() {
//     const [isEditing, setIsEditing] = useState(false);
//     const [isAdmin, setIsAdmin] = useState(false);
//     const [formData, setFormData] = useState({
//         targrt: [{ title: '', description: '' }],
//         core: [{ title: '', description: '' }],
//         thirdSection: [{ title: '', description: '' }],
//         fourthSection: [{ title: '', description: '' }]
//     });

//     useEffect(() => {
//         fetchData();
//         const adminStatus = localStorage.getItem('isAdmin');
//         setIsAdmin(adminStatus === 'Y');
//     }, []);

//     const fetchData = async () => {
//         try {
//             const token = localStorage.getItem('authToken');
//             const response = await fetch(Api.API_BASE_URL + 'business-core/vision/marketing/get', {
//                 method: 'GET',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': token ? `Bearer ${token}` : '',
//                 },
//             });
//             const data = await response.json();
//             if (Array.isArray(data.result)) {
//                 const mappedData = data.result.map(item => ({
//                     title: item.title || '',
//                     description: item.description || ''
//                 }));
//                 setFormData({ 
//                     targrt: mappedData.length > 0 ? mappedData : [{ title: '', description: '' }],
//                     core: mappedData.length > 0 ? mappedData : [{ title: '', description: '' }],
//                     thirdSection: mappedData.length > 0 ? mappedData : [{ title: '', description: '' }],
//                     fourthSection: mappedData.length > 0 ? mappedData : [{ title: '', description: '' }]
//                 });
//             } else {
//                 setFormData({ 
//                     targrt: [{ title: '', description: '' }],
//                     core: [{ title: '', description: '' }],
//                     thirdSection: [{ title: '', description: '' }],
//                     fourthSection: [{ title: '', description: '' }]
//                 });
//             }
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };

//     const handleEditToggle = () => {
//         if (isEditing) {
//             handleSave();
//         } else {
//             setIsEditing(true);
//         }
//     };

//     const handleSave = async () => {
//         setIsEditing(false);
//         try {
//             const token = localStorage.getItem('authToken');
//             const payload = {
//                 go_to_market_strategy: formData.targrt,
//                 core_values: formData.core,
//                 third_section: formData.thirdSection,
//                 fourth_section: formData.fourthSection
//             };

//             const response = await fetch(Api.API_BASE_URL + 'business-core/vision/marketing/save', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': token ? `Bearer ${token}` : ''
//                 },
//                 body: JSON.stringify(payload),
//             });

//             if (!response.ok) {
//                 throw new Error('Network response was not ok');
//             }

//             const result = await response.json();
//             console.log('Data saved successfully:', result);
//         } catch (error) {
//             console.error('Error saving data:', error);
//         }
//     };

//     const handleInputChange = (e, field, index, section) => {
//         const newData = [...formData[section]];
//         newData[index][field] = e.target.value;
//         setFormData({
//             ...formData,
//             [section]: newData,
//         });
//     };

//     const handleAddField = (section) => {
//         setFormData({
//             ...formData,
//             [section]: [...formData[section], { title: '', description: '' }]
//         });
//     };

//     const handleDelete = (index, section) => {
//         const newData = [...formData[section]];
//         newData.splice(index, 1);
//         setFormData({
//             ...formData,
//             [section]: newData
//         });
//     };

//     const textareaStyle = {
//         width: '90%',
//         height: "40px",
//         boxSizing: 'border-box',
//         outline: 'none',
//         fontSize: '16px',
//         color: '#495057',
//         display: 'flex',
//         alignItems: 'center',
//         padding: '8px',
//         border: '1px solid #ccc',
//     };

//     return (
//         <div className="box2">
//             <div className="box-header">
//                 <h4 className='title-font'>Go to Market Strategy</h4>
//                 {isAdmin && (
//                     <div onClick={handleEditToggle} style={{ cursor: 'pointer' }}>
//                         {isEditing ? (
//                             <IoIosCheckmark style={{ fontSize: '40px' }} />
//                         ) : (
//                             <IoMdCreate style={{ fontSize: '20px' }} />
//                         )}
//                     </div>
//                 )}
//             </div>
//             {/* -------First Section Start--------------- */}
//             <div className="box-body">
//                 {isEditing ? (
//                     <>
//                         {formData.targrt.map((field, index) => (
//                             <div key={index} style={{ marginTop: '10px', alignItems: 'center' }}>
//                                 <div style={{ flex: 1 }}>
//                                     <label htmlFor={`title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Title
//                                     </label>
//                                     <div className="flex">
//                                         <InputTextarea
//                                             id={`title-${index}`}
//                                             type="text"
//                                             autoResize
//                                             value={field.title}
//                                             onChange={(e) => handleInputChange(e, 'title', index, 'targrt')}
//                                             style={textareaStyle}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div style={{ flex: 2, marginTop: '10px' }}>
//                                     <label htmlFor={`description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Description
//                                     </label>
//                                     <Editor
//                                         id={`description-${index}`}
//                                         value={field.description}
//                                         onTextChange={(e) => handleInputChange({ target: { value: e.htmlValue } }, 'description', index, 'targrt')}
//                                         style={{ height: '150px', width: '100%' }}
//                                     />
//                                 </div>
//                             </div>
//                         ))}
//                     </>
//                 ) : (
//                     formData.targrt.map((field, index) => (
//                         <div className='row' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex' }}>
//                             <div className='col-12'>
//                                 <h4 className='mb-2'>{field.title}</h4>
//                                 <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
//                             </div>
//                         </div>
//                     ))
//                 )}
//             </div>
//             {/* -------First Section End--------------- */}

//             {/* -------Second Section Start--------------- */}
//             <div className="box-body">
//                 {isEditing ? (
//                     <>
//                         {formData.core.map((field, index) => (
//                             <div key={index} style={{ display: 'flex', gap: '10px', marginTop: '10px', fontSize: '14px' }}>
//                                 <div style={{ flex: 1 }}>
//                                     <label htmlFor={`value-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
//                                         Core Value*
//                                     </label>
//                                     <InputTextarea
//                                         id={`value-${index}`}
//                                         type="text"
//                                         autoResize
//                                         value={field.value}
//                                         onChange={(e) => handleInputChange(e, 'title', index, 'core')}
//                                         rows={2}
//                                         className='s'
//                                         style={textareaStyle}
//                                     />
//                                 </div>
//                                 <div style={{ flex: 2 }}>
//                                     <label htmlFor={`description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
//                                         Description*
//                                     </label>
//                                     <InputTextarea
//                                         autoResize
//                                         id={`description-${index}`}
//                                         value={field.description}
//                                         onChange={(e) => handleInputChange(e, 'description', index, 'core')}
//                                         style={textareaStyle}
//                                     />
//                                 </div>
//                                 {index > 0 ? (
//                                     <IoIosClose
//                                         onClick={() => handleDelete(index, 'core')}
//                                         style={{ fontSize: '40px', cursor: 'pointer', color: 'red' }}
//                                     />
//                                 ) : (
//                                     <IoIosAdd
//                                         onClick={() => handleAddField('core')}
//                                         style={{ fontSize: '40px', cursor: 'pointer' }}
//                                     />
//                                 )}
//                             </div>
//                         ))}
//                     </>
//                 ) : (
//                     formData.core.map((field, index) => (
//                         <div className='row' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex' }}>
//                             <div className='col-4'>
//                                 <p>{field.value}</p>
//                             </div>
//                             <div className='col-8'>
//                                 <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
//                             </div>
//                         </div>
//                     ))
//                 )}
//             </div>
//             {/* -------Second Section End--------------- */}

//             {/* -------Third Section Start--------------- */}
//             <div className="box-body">
//                 {isEditing ? (
//                     <>
//                         {formData.thirdSection.map((field, index) => (
//                             <div key={index} style={{ marginTop: '10px', alignItems: 'center' }}>
//                                 <div style={{ flex: 1 }}>
//                                     <label htmlFor={`third-title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Title
//                                     </label>
//                                     <div className="flex">
//                                         <InputTextarea
//                                             id={`third-title-${index}`}
//                                             type="text"
//                                             autoResize
//                                             value={field.title}
//                                             onChange={(e) => handleInputChange(e, 'title', index, 'thirdSection')}
//                                             style={textareaStyle}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div style={{ flex: 2, marginTop: '10px' }}>
//                                     <label htmlFor={`third-description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Description
//                                     </label>
//                                     <Editor
//                                         id={`third-description-${index}`}
//                                         value={field.description}
//                                         onTextChange={(e) => handleInputChange({ target: { value: e.htmlValue } }, 'description', index, 'thirdSection')}
//                                         style={{ height: '150px', width: '100%' }}
//                                     />
//                                 </div>
//                             </div>
//                         ))}
//                     </>
//                 ) : (
//                     formData.thirdSection.map((field, index) => (
//                         <div className='row' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex' }}>
//                             <div className='col-12'>
//                                 <h4 className='mb-2'>{field.title}</h4>
//                                 <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
//                             </div>
//                         </div>
//                     ))
//                 )}
//             </div>
//             {/* -------Third Section End--------------- */}

//             {/* -------Fourth Section Start--------------- */}
//             <div className="box-body">
//                 {isEditing ? (
//                     <>
//                         {formData.fourthSection.map((field, index) => (
//                             <div key={index} style={{ marginTop: '10px', alignItems: 'center' }}>
//                                 <div style={{ flex: 1 }}>
//                                     <label htmlFor={`fourth-title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Title
//                                     </label>
//                                     <div className="flex">
//                                         <InputTextarea
//                                             id={`fourth-title-${index}`}
//                                             type="text"
//                                             autoResize
//                                             value={field.title}
//                                             onChange={(e) => handleInputChange(e, 'title', index, 'fourthSection')}
//                                             style={textareaStyle}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div style={{ flex: 2, marginTop: '10px' }}>
//                                     <label htmlFor={`fourth-description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Description
//                                     </label>
//                                     <Editor
//                                         id={`fourth-description-${index}`}
//                                         value={field.description}
//                                         onTextChange={(e) => handleInputChange({ target: { value: e.htmlValue } }, 'description', index, 'fourthSection')}
//                                         style={{ height: '150px', width: '100%' }}
//                                     />
//                                 </div>
//                             </div>
//                         ))}
//                     </>
//                 ) : (
//                     formData.fourthSection.map((field, index) => (
//                         <div className='row' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex' }}>
//                             <div className='col-12'>
//                                 <h4 className='mb-2'>{field.title}</h4>
//                                 <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
//                             </div>
//                         </div>
//                     ))
//                 )}
//             </div>
//             {/* -------Fourth Section End--------------- */}
//         </div>
//     );
// }

// export default GoMarketStrategy;







import React, { useEffect, useState } from 'react';
import { IoMdCreate, IoIosCheckmark, IoIosAdd, IoIosClose } from "react-icons/io";
import { Editor } from "primereact/editor";
import { InputTextarea } from 'primereact/inputtextarea';
import { Api } from '../../../../services/api';

function GoMarketStrategy() {
    const [isEditing, setIsEditing] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [formData, setFormData] = useState({
        targrt: [{ title: '', description: '' }],
        core: [{ title: '', description: '' }],
        thirdSection: [{ title: '', description: '' }],
        fourthSection: [{ title: '', description: '' }]
    });

    useEffect(() => {
        fetchData();
        const adminStatus = localStorage.getItem('isAdmin');
        setIsAdmin(adminStatus === 'Y');
    }, []);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(Api.API_BASE_URL + 'business-core/vision/marketing/get', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : '',
                },
            });
            const data = await response.json();
            if (data.result) {
                const { sec1, sec2, sec3, sec4 } = data.result;
                setFormData({ 
                    targrt: sec1.length > 0 ? sec1 : [{ title: '', description: '' }],
                    core: sec2.length > 0 ? sec2 : [{ title: '', description: '' }],
                    thirdSection: sec3.length > 0 ? sec3 : [{ title: '', description: '' }],
                    fourthSection: sec4.length > 0 ? sec4 : [{ title: '', description: '' }]
                });
            } else {
                setFormData({ 
                    targrt: [{ title: '', description: '' }],
                    core: [{ title: '', description: '' }],
                    thirdSection: [{ title: '', description: '' }],
                    fourthSection: [{ title: '', description: '' }]
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleEditToggle = () => {
        if (isEditing) {
            handleSave();
        } else {
            setIsEditing(true);
        }
    };

    const handleSave = async () => {
        setIsEditing(false);
        try {
            const token = localStorage.getItem('authToken');
            const payload = {
                sec1: formData.targrt,
                sec2: formData.core,
                sec3: formData.thirdSection,
                sec4: formData.fourthSection
            };

            const response = await fetch(Api.API_BASE_URL + 'business-core/vision/marketing/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('Data saved successfully:', result);
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

    const handleInputChange = (e, field, index, section) => {
        const newData = [...formData[section]];
        newData[index][field] = e.target.value;
        setFormData({
            ...formData,
            [section]: newData,
        });
    };

    const handleAddField = (section) => {
        setFormData({
            ...formData,
            [section]: [{ title: '', description: '' }, ...formData[section], ]
        });
    };

    const handleDelete = (index, section) => {
        const newData = [...formData[section]];
        newData.splice(index, 1);
        setFormData({
            ...formData,
            [section]: newData
        });
    };

    const textareaStyle = {
        width: '90%',
        height: "40px",
        boxSizing: 'border-box',
        outline: 'none',
        fontSize: '16px',
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        border: '1px solid #ccc',
    };

    return (
        <div className="box2">
            <div className="box-header">
                <h4 className='title-font'>Go to Market Strategy</h4>
                {isAdmin && (
                    <div onClick={handleEditToggle} style={{ cursor: 'pointer' }}>
                        {isEditing ? (
                            <IoIosCheckmark style={{ fontSize: '40px' }} />
                        ) : (
                            <IoMdCreate style={{ fontSize: '20px' }} />
                        )}
                    </div>
                )}
            </div>
            {/* -------First Section Start--------------- */}
            <div className="box-body">
                {isEditing ? (
                    <>
                        {formData.targrt.map((field, index) => (
                            <div key={index} style={{ marginTop: '10px', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor={`title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Target Market*
                                    </label>
                                    <div className="flex">
                                        <InputTextarea
                                            id={`title-${index}`}
                                            type="text"
                                            autoResize
                                            value={field.title}
                                            onChange={(e) => handleInputChange(e, 'title', index, 'targrt')}
                                            style={textareaStyle}
                                        />
                                    </div>
                                </div>
                                <div style={{ flex: 2, marginTop: '10px' }}>
                                    <label htmlFor={`description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Description
                                    </label>
                                    <Editor
                                        id={`description-${index}`}
                                        value={field.description}
                                        onTextChange={(e) => handleInputChange({ target: { value: e.htmlValue } }, 'description', index, 'targrt')}
                                        style={{ height: '150px', width: '100%' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </>
                ) : (
                    formData.targrt.map((field, index) => (
                        <div className='row' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex', }}>
                            <div className='col-12 p-0'>
                                <h4 className='mb-2'>{field.title}</h4>
                                <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
                            </div>
                        </div>
                    ))
                )}
            </div>
            {/* -------First Section End--------------- */}

            {/* -------Second Section Start--------------- */}
            <div className="box-body ">
                {isEditing ? (
                    <>
                        {formData.core.map((field, index) => (
                            <div key={index} style={{ display: 'flex', gap: '10px', marginTop: '10px', fontSize: '14px' }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor={`value-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                    Uniques*
                                    </label>
                                  
                                     <InputTextarea
                                            id={`third-title-${index}`}
                                            type="text"
                                            autoResize
                                            value={field.title}
                                            onChange={(e) => handleInputChange(e, 'title', index, 'core')}
                                            style={textareaStyle}
                                        />
                                </div>
                                <div style={{ flex: 2 }}>
                                    <label htmlFor={`description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Description*
                                    </label>
                                    <InputTextarea
                                        autoResize
                                        id={`description-${index}`}
                                        value={field.description}
                                        onChange={(e) => handleInputChange(e, 'description', index, 'core')}
                                        style={textareaStyle}
                                    />
                                </div>
                                {index > 0 ? (
                                    <IoIosClose
                                        onClick={() => handleDelete(index, 'core')}
                                        style={{ fontSize: '40px', cursor: 'pointer', color: 'red' }}
                                    />
                                ) : (
                                    <IoIosAdd
                                        onClick={() => handleAddField('core')}
                                        style={{ fontSize: '40px', cursor: 'pointer' }}
                                    />
                                )}
                            </div>
                        ))}
                    </>
                ) : (
                    formData.core.map((field, index) => (
                        <div className='row pt-0' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex' }}>
                            <div className='col-4'>
                                <p>{field.title}</p>
                            </div>
                            <div className='col-8'>
                                <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
                            </div>
                        </div>
                    ))
                )}
            </div>
            {/* -------Second Section End--------------- */}

            {/* -------Third Section Start--------------- */}
            <div className="box-body py-0">
                {isEditing ? (
                    <>
                        {formData.thirdSection.map((field, index) => (
                            <div key={index} style={{ marginTop: '10px', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor={`third-title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                       Proven Process*
                                    </label>
                                    <div className="flex">
                                        <InputTextarea
                                            id={`third-title-${index}`}
                                            type="text"
                                            autoResize
                                            value={field.title}
                                            onChange={(e) => handleInputChange(e, 'title', index, 'thirdSection')}
                                            style={textareaStyle}
                                        />
                                    </div>
                                </div>
                                <div style={{ flex: 2, marginTop: '10px' }}>
                                    <label htmlFor={`third-description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Description*
                                    </label>
                                    <Editor
                                        id={`third-description-${index}`}
                                        value={field.description}
                                        onTextChange={(e) => handleInputChange({ target: { value: e.htmlValue } }, 'description', index, 'thirdSection')}
                                        style={{ height: '150px', width: '100%' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </>
                ) : (
                    formData.thirdSection.map((field, index) => (
                        <div className='row ' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex' }}>
                            <div className='col-12 p-0'>
                                <h4 className='my-2'>{field.title}</h4>
                                <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
                            </div>
                        </div>
                    ))
                )}
            </div>
            {/* -------Third Section End--------------- */}

            {/* -------Fourth Section Start--------------- */}
            <div className="box-body py-0">
                {isEditing ? (
                    <>
                        {formData.fourthSection.map((field, index) => (
                            <div key={index} style={{ marginTop: '10px', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor={`fourth-title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Guarantee*
                                    </label>
                                    <div className="flex">
                                        <InputTextarea
                                            id={`fourth-title-${index}`}
                                            type="text"
                                            autoResize
                                            value={field.title}
                                            onChange={(e) => handleInputChange(e, 'title', index, 'fourthSection')}
                                            style={textareaStyle}
                                        />
                                    </div>
                                </div>
                                <div style={{ flex: 2, marginTop: '10px' }}>
                                    <label htmlFor={`fourth-description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Description
                                    </label>
                                    <Editor
                                        id={`fourth-description-${index}`}
                                        value={field.description}
                                        onTextChange={(e) => handleInputChange({ target: { value: e.htmlValue } }, 'description', index, 'fourthSection')}
                                        style={{ height: '150px', width: '100%' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </>
                ) : (
                    formData.fourthSection.map((field, index) => (
                        <div className='row' key={index} style={{ padding: '2px 2px', borderRadius: '5px', display: 'flex' }}>
                            <div className='col-12 p-0' >
                                <h4 className='my-2'>{field.title}</h4>
                                <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
                            </div>
                        </div>
                    ))
                )}
            </div>
            {/* -------Fourth Section End--------------- */}
        </div>
    );
}

export default GoMarketStrategy;